var _style, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlusLogoLight = function SvgPlusLogoLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PlusLogoLight_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".PlusLogoLight_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PlusLogoLight_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PlusLogoLight_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "PlusLogoLight_svg__st1",
    d: "M25.7 22.8h.5v-6.5l8.1 1.3-.1 9.6 4.9-2.2v-9.6L30.5 14l-4.8 2.2zM28.3 25.4l-4.8 2.2v9.6-.5l-6.6-.9v.5l6.6.9 4.8-2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "PlusLogoLight_svg__st1",
    d: "M28.3 25.4L19.8 24l-4.9 2.2 8.6 1.4zM45.2 31.1l4.6-2.1-8.6-1.4-4.8 2.2 8.6 1.4v9.6l4.8-2.2V29zM34.2 50.8l4.9-2.2V39l-4.8 2.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "PlusLogoLight_svg__st1",
    d: "M34.3 41.2l4.8-2.2-8.6-1.4-4.8 2.2v7l.5.1v-7l-.2-.1zM40.8 40.1l4.2.7v-.5l-4.2-.7z"
  })));
};
export default SvgPlusLogoLight;